



<form [formGroup]="passwordForm">  
  
      <!--password input filed-->
      <mat-form-field appearance="outline" style="width: 100%" [color]="passwordComponent.color">
        <mat-label>Password</mat-label>
        <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility>
        <input matInput #password
        id="password"
        [type]="toggle.type"
        formControlName="password"
               required
               placeholder="Password">
              
        <mat-hint align="end" aria-live="polite">
          {{password.value.length}} / {{passwordComponent.max}}
        </mat-hint>
      </mat-form-field>
  
      <mat-password-strength #passwordComponent
                             (onStrengthChanged)="onStrengthChanged($event)"
                             [enableSpecialCharRule]="false"
                             [password]="password.value">
      </mat-password-strength>
      <!--Password's strength info-->
      <mat-password-strength-info 
          [ngClass]="{'closed':hidePasswordInfo}"
        *ngIf="showDetails"
        [passwordComponent]="passwordComponent">
      </mat-password-strength-info>
  </form>